import React from 'react';

import { TreeOpenStateContext } from '@lumapps/lumx/utils/TreeOpenStateContext';

export const CLASSNAME = 'expandable-tree-panel';

/**
 * Hook to be used in the expandable tree
 */
export const useExpandableTreeContext = ({ itemId }: { itemId?: string }) => {
    const context = React.useContext(TreeOpenStateContext);

    const onOpenMenu = (open: boolean) => {
        if (context && itemId) {
            context.setOpenedSubMenu(open ? itemId : undefined);
        }
    };

    const isOpenWhenContextIsEnabled = Boolean(
        context && context.openedSubMenu && itemId && context.openedSubMenu.includes(itemId),
    );

    return {
        isOpenWhenContextIsEnabled,
        onOpenMenu,
        context,
    };
};
